import React from 'react'

const Footer = () => {
    return (
       <React.Fragment>
           <footer>
        <div className="container text-secondary text-center pt-5">

            <p>© 2019-2020 Company, icoder. </p>
      
        </div>
    </footer>


       </React.Fragment>
    )
}

export default Footer
